import { render, staticRenderFns } from "./ExcursionTicker.vue?vue&type=template&id=ef5ae05e"
import script from "./ExcursionTicker.js?vue&type=script&lang=js&external"
export * from "./ExcursionTicker.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports